/**
 * CSV export helpers for Excel PT-BR compatibility.
 * Excel in Portuguese (Brazil) uses semicolon (;) as list separator by default.
 */

export const CSV_DELIMITER = ';'
export const CSV_BOM = '\uFEFF'

/**
 * Escapes a single CSV field: wraps in double quotes and doubles internal quotes
 * when the value contains the delimiter, double quote, or newline.
 */
export function escapeCsvField(value: string): string {
  const str = String(value ?? '')
  if (str.includes(CSV_DELIMITER) || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

/**
 * Builds one CSV row from an array of field values (will escape each field).
 */
export function toCsvRow(fields: (string | number | null | undefined)[], delimiter: string = CSV_DELIMITER): string {
  return fields.map((f) => escapeCsvField(String(f ?? ''))).join(delimiter)
}

/**
 * Builds full CSV content with BOM for UTF-8 (so Excel recognizes special characters).
 */
export function buildCsvWithBom(lines: string[]): string {
  return CSV_BOM + lines.join('\n')
}
